import { Injector } from '@angular/core';
import { Router } from '@angular/router';
import { WorkflowFormsService } from '@app/finxone-web-frontend/app/lib/services/workflow-forms/workflow-forms.service';
import { FormID } from '@finxone-platform/form-action';
import { AlertHandlerService } from '@finxone-platform/shared/services';
import {
  ActionButtonOutcomesType,
  AlertTypes,
  UiZoneWidgetAttributeConfig,
} from '@finxone-platform/shared/sys-config-types';
import { catchError, tap } from 'rxjs';
import { CtaButtonSignalService } from '../../../services/cta-button-signal-service/cta-button-signal.service';
import { SavingsAccountService } from '../../../services/savings-account-service/savings-account.service';
import { redirectToPage } from '../cta-button-actions.utils';
import { handleRedirection } from '../cta-redirection.utils';
import { CloseSavingsAccountRequest } from '../../../services/savings-account-service/savings-account.type';

export function initiateCloseSavingsAccount(injector: Injector, attri: UiZoneWidgetAttributeConfig) {
  const ctaButtonSignalService = injector.get(CtaButtonSignalService);
  const savingsAccountService = injector.get(SavingsAccountService);
  const workflowFormsService = injector.get(WorkflowFormsService);
  const alertHandlerService = injector.get(AlertHandlerService);

  const allPageFormValues = workflowFormsService.getAllFormValuesFlattened();

  const currentPageFormValues = allPageFormValues[FormID.CLOSING_ACCOUNT_FORM];

  if (!currentPageFormValues?.['accountId']) {
    console.error('Account id not found');
    return alertHandlerService.showAlertFn(AlertTypes.ERROR, 'Account id not found');
  }

  const ctaAction = attri.widgetProperties.buttonActionType as string;

  // disable button on click
  ctaButtonSignalService.setSignal({ [ctaAction]: false });

  const payload: CloseSavingsAccountRequest = {
    closureReason: currentPageFormValues?.['closureReason'],
  };

  savingsAccountService
    .closeSavingsAccount(currentPageFormValues?.['accountId'], payload)
    .pipe(
      tap(() => {
        ctaButtonSignalService.setSignal({ [ctaAction]: true });
        navigateToConfiguredScreen(injector, attri, ActionButtonOutcomesType.SUCCESS);
      }),
      catchError((error) => {
        ctaButtonSignalService.setSignal({ [ctaAction]: true });
        navigateToConfiguredScreen(injector, attri, ActionButtonOutcomesType.FAILURE);
        throw error;
      }),
    )
    .subscribe();
}

const navigateToConfiguredScreen = (
  injector: Injector,
  attri: UiZoneWidgetAttributeConfig,
  actionButtonOutComeType: ActionButtonOutcomesType,
) => {
  if (attri.widgetProperties?.actionNavigationConfigurations) {
    handleRedirection(attri.widgetProperties, injector, actionButtonOutComeType, true);
  } else {
    redirectToPage(injector.get(Router), attri.widgetProperties, injector);
  }
};
